import { LocalstorageTokensKeys } from '../../app/shared/models/tokens-keys.interface';

const prefix = 'marid_client_';

export const localstorageTokensKeys: LocalstorageTokensKeys = {
  accessToken: `${prefix}access_token`,
  refreshToken: `${prefix}refresh_token`,
  lang: `${prefix}lang`,
  tokenExpiry: `${prefix}token_expiry`,
  theme: `${prefix}theme`,
  userData: `${prefix}user_data`,
  isSubscribed: `${prefix}is_subscribed`,
};
